<template>
  <div>
    <div
      v-for="(job, index) in sortedJobs.slice(0, 3)"
      :key="job.slug"
      :class="[
        'carousel-item',
        { active: index === 0 },
        'py-3',
        'px-3',
        'px-md-5',
        'py-md-3',
      ]"
      style="height: 145px"
    >
      <a
        ref="titleRef"
        :href="'/stellenangebot/' + job.slug"
        class="fw-normal h3 text-decoration-none stretched-link text-white"
        style="
          display: block;
          width: 100%;
          overflow: hidden;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        "
      >
        {{ job.title }}
      </a>
      <p class="mb-0 mt-2">
        <span class="d-inline-block me-3">
          <template v-if="job.workplaces">
            <i class="fas fa-map-marker"></i>
            {{ job.workplaces[0].city }}
            <template v-if="job.workplaces[0].distance_in_km > 0">
              ({{ job.workplaces[0].distance_in_km.toString().replace(".", ",") }}km)
            </template>
            <template v-if="job.workplaces.length > 2">
              + {{ job.workplaces.length - 1 }} weitere Orte
            </template>
            <template v-else-if="job.workplaces.length > 1">
              und {{ job.workplaces[1].city }}
            </template>
          </template>
        </span>
        <span v-if="job.type" class="d-inline-block me-3">
          <i class="fas fa-fw fa-clock"></i>
          {{ job.type }}
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ref, onMounted, computed } from "vue";

export default {
  props: {
    apiEndpoints: Object,
    getParameters: Object,
  },
  setup(props) {
    const latestJobs = ref([]);

    onMounted(() => {
      performSearch();
    });

    const sortedJobs = computed(() =>
      latestJobs.value.sort((a, b) => {
        const aDate = new Date(a.date);
        const bDate = new Date(b.date);
        return bDate - aDate;
      })
    );

    // search method
    const performSearch = () => {
      axios
        // EDIT: use the apiEndpoints prop to get the correct endpoint
        // QUICK AND DIRTY
        .get("/ajax/L2NsaWVudC80OS9qb2Jz?search", {
          params: props.getParameters,
        })
        .then((response) => {
          latestJobs.value = response.data;
        })
        .catch((error) => {
          console.error("Error fetching latest jobs:", error);
        });
    };

    return {
      latestJobs,
      sortedJobs,
    };
  },
  mounted() {
    this.$nextTick(() => {
      // Compute the maximum height of two lines of text
      const titleElement = this.$refs.titleRef;
      if (!titleElement) {
        return;
      }
      const fontSize = window
        .getComputedStyle(titleElement)
        .getPropertyValue("font-size");
      const lineHeight = window
        .getComputedStyle(titleElement)
        .getPropertyValue("line-height");
      const maxTwoLinesHeight = parseFloat(fontSize) * parseFloat(lineHeight) * 2;

      // Check if the title overflows two lines of text and apply ellipsis if it does
      const actualHeight = titleElement.getBoundingClientRect().height;
      if (actualHeight > maxTwoLinesHeight) {
        titleElement.style.textOverflow = "ellipsis";
        titleElement.style.whiteSpace = "nowrap";
      }
    });
  },
  computed: {
    sortedJobs() {
      return this.latestJobs.sort((a, b) => {
        const dateA = new Date(a.created_at);
        const dateB = new Date(b.created_at);
        return dateB - dateA;
      });
    },
  },
};
</script>
